<mat-tab-group id="notificationDlg" #contentZone (selectedTabChange)="selectedTabChange($event)" #tabs *ngIf="tabIndex !== -1">
  <mat-tab *ngIf="!authService.isEximUser">
    <ng-template mat-tab-label>
      <div class="tabLabel" [ngClass]="{'withDot': countEvents }">{{ 'header.notifications.events_txt' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <dp-event-tab [type]="NotificationTypes.EVENT" fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill class="tabContainer"
        [opened]="tabIndex === 0" (allRead)="allRead(NotificationTypes.EVENT)" (partialRead)="partialRead(NotificationTypes.EVENT)"
        [hasUnread]="countEvents"></dp-event-tab>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <div class="tabLabel" [ngClass]="{'withDot': countExceptions }">
        {{ 'common.exceptions_txt' | translate }}
      </div>
    </ng-template>

    <ng-template matTabContent>
      <!-- Non-Exim → legacy component -->
      <ng-container *ngIf="!authService.isEximUser; else eximExceptions">
        <dp-event-tab
          [type]="NotificationTypes.EXCEPTION"
          fxLayout="column"
          fxLayoutAlign="start stretch"
          fxFlexFill
          class="tabContainer"
          [opened]="tabIndex === 1"
          (allRead)="allRead(NotificationTypes.EXCEPTION)"
          (partialRead)="partialRead(NotificationTypes.EXCEPTION)"
          [hasUnread]="countExceptions"
        ></dp-event-tab>
      </ng-container>

      <!-- Exim → V2 component -->
      <ng-template #eximExceptions>
        <dp-event-tab-v2
          [type]="NotificationTypes.EXCEPTION"
          fxLayout="column"
          fxLayoutAlign="start stretch"
          fxFlexFill
          class="tabContainer"
          [opened]="tabIndex === 0"
          (allRead)="allRead(NotificationTypes.EXCEPTION)"
          (partialRead)="partialRead(NotificationTypes.EXCEPTION)"
          [hasUnread]="countExceptions"
        >
        </dp-event-tab-v2>
      </ng-template>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="!authService.isEximUser">
    <ng-template mat-tab-label>
      <div class="tabLabel" [ngClass]="{'withDot': countSystems }">{{ 'header.notifications.others_txt' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <dp-event-tab [type]="NotificationTypes.SYSTEM" fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill class="tabContainer"
        [opened]="tabIndex === 2" (allRead)="allRead(NotificationTypes.SYSTEM)" (partialRead)="partialRead(NotificationTypes.SYSTEM)"
        [hasUnread]="countSystems"></dp-event-tab>
    </ng-template>
  </mat-tab>
</mat-tab-group>